import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CloudStorage from "../../../CloudStorage/CloudStorage";
import TeamsInviteExpertModel from "./TeamTabs/TeamsModels/TeamsInviteExpertModel";
import { Modal } from "reactstrap";
import { getTeamOverview } from "../../../redux/team/action";
import FullTeamOverview from "./TeamTabs/FullTeamOverview";
import TeamMembers from "./TeamMembers/TeamMembers";
import TeamsJoinCompnyExpertModel from "./TeamTabs/TeamsModels/TeamsJoinCompnyExpertModel";
import PostNotFound from "../../CustomComponents/AllLoader/PostNotFound";
import LeaveCompanyModel from "./TeamTabs/TeamsModels/LeaveCompanyModel";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import ProfilePic from "../../../assests/imgs/Profileplaceholder.svg";

export default function TeamAndCollaboration() {
  const { setTeamMemberroute, urlstate } = useRouteBaseStateContext();
  const dispatch = useDispatch();
  const [inivitemodel, setiniviteModel] = useState(false);
  const [joinmodel, setJoinModel] = useState(false);
  const [leavemodel, setLeavemodel] = useState(false);
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const teamoverview = useSelector(
    ({ team: { getteamoverviews } }) => getteamoverviews
  );

  useEffect(() => {
    dispatch(getTeamOverview());
  }, []);

  return (
    <>
      {teamoverview?.company_id ? (
        <div className="project-section manage-team">
          <div className="manageteam-left">
            <h4 className="font-42" onClick={() => setTeamMemberroute(false)}>
              <span>
                <img
                  src={
                    teamoverview?.profile_image
                      ? teamoverview?.profile_image
                      : ProfilePic
                  }
                  className="w-100"
                  alt=""
                />
              </span>
              {teamoverview?.company_name}
            </h4>
            <div className="manage-right">
              {profile?.role_type == 3 ? (
                <a
                  className="buttons border-button"
                  onClick={() => {
                    setLeavemodel(true);
                  }}
                >
                  <span style={{ fontSize: "20px" }}>&#10005;</span>Leave
                  Team
                </a>
              ) : (
                ""
              )}
              {profile?.role_type == 4 ? (
                <a
                  className="buttons border-button"
                  onClick={() => setiniviteModel(true)}
                >
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`}
                    alt=""
                  />
                  Invite members
                </a>
              ) : (
                ""
              )}
              <a
                className="buttons border-button"
                onClick={() => setTeamMemberroute(!urlstate?.teammember)}
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/team.svg`}
                  alt=""
                />
                {teamoverview?.members}
              </a>
            </div>
          </div>

          {urlstate?.teammember ? (
            <TeamMembers teamoverview={teamoverview} />
          ) : (
            <FullTeamOverview teamoverview={teamoverview} />
          )}

          <Modal
            className="popupmodal teaminvite modal-width "
            isOpen={inivitemodel}
          >
            <TeamsInviteExpertModel setiniviteModel={setiniviteModel} />
          </Modal>
        </div>
      ) : (
        <div className="project-section manage-team">
          <div className="manageteam-left">
            <h4 className="font-42" onClick={() => setTeamMemberroute(false)}>
              <span>
                <img
                  src={
                    teamoverview?.profile_image
                      ? teamoverview?.profile_image
                      : ProfilePic
                  }
                  className="w-100"
                  alt=""
                />
              </span>
              Send Request to Join Team
            </h4>

            <div className="manage-right">
              <a
                className="buttons border-button"
                onClick={() => setJoinModel(true)}
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`}
                  alt=""
                />
                Send Request
              </a>
            </div>
          </div>
          <PostNotFound title={"Send Request to Join Team"} />
        </div>
      )}
      <Modal className="popupmodal teaminvite modal-width " isOpen={joinmodel}>
        <TeamsJoinCompnyExpertModel setJoinModel={setJoinModel} />
      </Modal>
      <Modal className="popupmodal" isOpen={leavemodel}>
        <LeaveCompanyModel
          setLeavemodel={setLeavemodel}
          companyid={teamoverview?.company_id}
        />
      </Modal>
    </>
  );
}
